import { Button, Modal, ModalCloseButton, ModalDescription, ModalFooter, ModalHeader, NotificationDispatch, TextField } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { useForm } from 'src/common/form';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { useUpdateTokensMutation } from '../../corporate.slice';
import { CorpSideButton, StyledButtonIcon } from '../../corporate.styles';
import type { UpdateTokenModalProps, UpdateTokenProps } from '../../corporate.types';
import { StyledModalTitle, StyledTextField } from '../add-seat-modal/add-seat-modal.styles';
export const UpdateTokenModal = ({
  companyId,
  title,
  numberOfTokens,
  isAddToken,
  buttonTitle,
  icon
}: UpdateTokenModalProps) => {
  const [updateTokens] = useUpdateTokensMutation();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const handleModalClose = () => {
    setModalOpen(false);
    reset();
  };
  const {
    register,
    getValues,
    reset,
    handleSubmit
  } = useForm<UpdateTokenProps>({
    defaultValues: {
      companyId: '',
      tokens: ''
    }
  });
  const onSubmit = async () => {
    try {
      setSubmitting(true);
      const {
        tokens
      }: UpdateTokenProps = getValues();
      await updateTokens({
        companyId,
        tokens: Number.parseInt(tokens, 10),
        operation: isAddToken ? 'increment' : 'decrement'
      }).unwrap();
      NotificationDispatch('success', "Token's amount updated successfully");
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
    handleModalClose();
    reset();
    setSubmitting(false);
  };
  return <Modal triggerElement={<CorpSideButton color="secondary">
          <StyledButtonIcon icon={icon} size="lg" />
          {buttonTitle}
        </CorpSideButton>} open={modalOpen} onOpenChange={open => setModalOpen(open)} preventOnOpenAutoFocus isSmall data-sentry-element="Modal" data-sentry-component="UpdateTokenModal" data-sentry-source-file="update-token-modal.tsx">
      <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="update-token-modal.tsx">
        <StyledModalTitle isSmall data-sentry-element="StyledModalTitle" data-sentry-source-file="update-token-modal.tsx">{title}</StyledModalTitle>
      </ModalHeader>
      <ModalDescription data-sentry-element="ModalDescription" data-sentry-source-file="update-token-modal.tsx">{numberOfTokens} tokens currently on dashboard</ModalDescription>
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form id="update-tokens" method="dialog" onSubmit={handleSubmit(onSubmit)}>
        {isAddToken ? <StyledTextField>
            <TextField {...register('tokens')} id="add-token-id" label="Number of tokens" variant="input" type="number" min={1} />
          </StyledTextField> : <StyledTextField>
            <TextField {...register('tokens')} id="remove-token-id" label="Number of tokens to remove" variant="input" type="number" min={1} />
          </StyledTextField>}
        <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="update-token-modal.tsx">
          <ModalCloseButton text="Cancel" handleCloseButtonAction={() => reset()} data-sentry-element="ModalCloseButton" data-sentry-source-file="update-token-modal.tsx" />
          <Button type="submit" color="primary" variant="solid" disabled={submitting} data-sentry-element="Button" data-sentry-source-file="update-token-modal.tsx">
            {isAddToken ? 'Add Tokens' : 'Remove Tokens'}
          </Button>
        </ModalFooter>
      </form>
    </Modal>;
};